export const clock = {
    totalSeconds: 0,
    start: function() {
        var self = this;
        this.interval = setInterval(function() {
            self.totalSeconds += 1;
            window.timer = parseInt(self.totalSeconds);
            // console.log( window.timer)
        }, 1000);
    },
    pause: function() {
        clearInterval(this.interval);
        delete this.interval;
    },
    resume: function() {
        if (!this.interval) this.start();
    },
    clear: function() {
        this.totalSeconds = 0;
    },
    destroy: function () {
        clearInterval(this.interval);
        delete this.interval;
    }
};

export const DurationToSeconds = (ContentDuration) => {
  var duration;
  let timeArray = ContentDuration?.split(":");
  if (timeArray.length > 0) {
    if (
      Number(timeArray[0]) === 0 &&
      Number(timeArray[1]) === 0 &&
      Number(timeArray[2]) === 0
    ) {
    } else {
      if (Number(timeArray[0]) === 0) {
        if (Number(timeArray[1]) === 0) {
          duration = Number(timeArray[2]);
        } else {
          duration = Number(timeArray[1]) * 60 + Number(timeArray[2]);
        }
      } else {
        if (Number(timeArray[1]) === 0) {
          duration = Number(timeArray[0]) * 60 * 60 + Number(timeArray[2]);
        } else {
          duration =
            Number(timeArray[0]) * 60 * 60 +
            Number(timeArray[1]) * 60 +
            Number(timeArray[2]);
        }
      }
    }
  }
  return duration;
};